<template>
    <div id="app">
        <Preloader/>
        <router-view/>
    </div>
</template>
<script>
    import Preloader from "./components/Preloader";

    export default {
        components: {
            Preloader
        }
    }

</script>

<style lang="less">
    #app {
        padding: 0;
        margin: 0;
    }
</style>
